//video modal
jQuery( document ).ready(function() {
jQuery( "span.close" ).click(function() {
  jQuery("#mpopupBox > div > div > div.modal-body > iframe").attr("src", jQuery("#mpopupBox > div > div > div.modal-body > iframe").attr("src"));
  jQuery("#mpopupBox").hide();
});
jQuery( ".video-modal" ).click(function() {
   jQuery("#mpopupBox").show();
});  
});

// banner slider
$( document ).ready(function() {	
$('.logo-slider').slick({
	slidesToShow: 5,
	slidesToScroll: 1,
	dots: false,
	arrows: true,
	autoplay: false,
	autoplaySpeed: 2000,
	infinite: false,
    responsive: [
    {
      breakpoint: 968,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 520,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },    
  ],
});
});

//category filter slider	
$( document ).ready(function() {	      
$('#adventure-slider').slick({
	slidesToShow: 4,
	slidesToScroll: 2,
	dots: false,
	arrows: true,
	autoplay: true,
	infinite: true,
    useTransform: false,
  responsive: [
    {
      breakpoint: 968,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 520,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },    
  ],
});
});

$( document ).ready(function() {	
$(function(){  
  
  // When the filter values are changed, 
  // apply the filter to slick.
  $('#slide-list li').on('click', function() {
    var filterClass = '.' + $(this).text().toLowerCase();
    $('#adventure-slider').slick('slickUnfilter');
    $('#adventure-slider').slick('slickFilter', filterClass);
     
  });
   
});
});    
 

//product columns
$( document ).ready(function() {		
$('#product-colums').slick({
	slidesToShow: 2,
	slidesToScroll: 1,
	dots: false,
	arrows: true,
	autoplay: false,
	infinite: true,
    useTransform: false,
  responsive: [
    {
      breakpoint: 968,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 520,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },    
  ],
});
});   
    
//filterable slider
$( document ).ready(function() {
$("#slide-list > li").click( function(){
    if ( $(this).hasClass('active') ) {
        $(this).removeClass('active');
    } else {
        $('#slide-list > li.active').removeClass('active');
        $(this).addClass('active');    
    }
});
});

